import * as def from '@/definitions'
import { Rectangle } from '@/utilityModels/rectangle'
import { Vector2 } from '@/utilityModels/vector2';
import { MathHelper } from '@/helper/mathHelper';
import { UuidHelper } from '@/helper/uuidHelper';

export class Layer
{
    // レイヤー種別
    public get layerType() : string { return ""; }

    // レイヤー固有ID
    private _id : string = "";
    public get id() : string { return this._id; }
    public set id(id : string) { this._id = id; }

    // 差し込みID
    private _insertionId : string = "";
    public get insertionId() : string { return this._insertionId; }
    public set insertionId(insertionId : string) { this._insertionId = insertionId; }
    
    // 位置
    public get x() : number { return 0; }
    public set x(x: number) { /* nothing */ }
    public get y() : number { return 0; }
    public set y(y: number) { /* nothing */ }

    // サイズ
    public get width() : number { return 0; }
    public set width(width: number) { /* nothing */ }
    public get height() : number { return 0; }
    public set height(height: number) { /* nothing */ }
    
    // 回転角
    public get rotate() : number { return 0; }
    public set rotate(rotate: number) { /* nothing */ }

    // 中心点
    public get centerX() : number { return this.originX + this.width / 2; }
    public get centerY() : number { return this.originY + this.height / 2; }

    // 回転前の位置
    public get originX() : number { return this.x; }
    public get originY() : number { return this.y; }

    // オブジェクト名
    private _name : string = "";
    public get name() : string { return this._name }
    public set name(name : string) { this._name = name }

    // 選択されているか
    private _isSelected : boolean = false;
    public get isSelected() : boolean { return this._isSelected }
    public set isSelected(isSelected : boolean) { this._isSelected = isSelected }

    // ロック中かどうか
    private _isLocked : boolean = false;
    public get isLocked() : boolean { return this._isLocked; }
    public set isLocked(isLocked : boolean) { this._isLocked = isLocked; }

    constructor()
    {
        // GUIDを固有IDとして設定する
        this._id = UuidHelper.getUuid();
        
        // オブジェクト名(仮)
        this._name = "オブジェクト_" + this._id
    }

    // ある点がレイヤー上にあるかどうかを取得する
    public isPointContained(x : number, y : number) : boolean
    {
        return MathHelper.isPointInPolygon(new Vector2(x, y), this.getVertexes());
    }

    // ある矩形範囲にレイヤーが含まれるかどうかを取得する
    public isRectContained(x : number, y : number, width : number, height : number) : boolean
    {
        // 原則として、頂点で囲んだ矩形同士の当たり判定をとる。
        var rectVertexes = [
            new Vector2(x, y), 
            new Vector2(x, y + height),
            new Vector2(x + width, y + height),
            new Vector2(x + width, y)
        ];
        // 交差している、または内包している
        return MathHelper.isPolygonCrossing(rectVertexes, this.getVertexes()) ||
            MathHelper.isPolygonInPolygon(rectVertexes, this.getVertexes());
    }

    // 頂点を得る
    public getVertexes() : Vector2[]
    {
        var vertexes : Vector2[] = [];
        
        // 回転前の頂点
        var ver : Vector2[] = [];
        ver.push(new Vector2(this.originX, this.originY));
        ver.push(new Vector2(this.originX, this.originY + this.height));
        ver.push(new Vector2(this.originX + this.width, this.originY + this.height));
        ver.push(new Vector2(this.originX + this.width, this.originY));
        
        // 回転
        for(var i = 0; i < ver.length; ++i)
        {
            vertexes.push(ver[i].rotateDegrees(this.rotate, this.centerX, this.centerY));
        }

        return vertexes;
    }

    // 外接矩形を得る
    public getBoundingRect() : Rectangle
    {
        var rect = new Rectangle();

        // 頂点で判定する
        var minX = 0;
        var minY = 0;
        var maxX = 0;
        var maxY = 0;
        var vertexes = this.getVertexes();
        for(var i = 0; i < vertexes.length; ++i)
        {
            var vertex = vertexes[i];
            minX = i == 0 ? vertex.x : Math.min(vertex.x, minX);
            minY = i == 0 ? vertex.y : Math.min(vertex.y, minY);
            maxX = i == 0 ? vertex.x : Math.max(vertex.x, maxX);
            maxY = i == 0 ? vertex.y : Math.max(vertex.y, maxY);
        }

        rect.x = minX;
        rect.y = minY;
        rect.width = maxX - minX;
        rect.height = maxY - minY;

        return rect;

        // // 回転角で求め方を変える。
        // var width = 0;
        // var height = 0;
        // var radian = this.rotate * Math.PI / 180;
        // if (0 <= this.rotate && this.rotate < 90)
        // {
        //     width = this.width * Math.cos(radian) + this.height * Math.sin(radian);
        //     height = this.height * Math.cos(radian) + this.width * Math.sin(radian);
        // }
        // else if (90 <= this.rotate && this.rotate <= 180)
        // {
        //     width = this.height * Math.cos(radian - Math.PI / 2) + this.width * Math.sin(radian - Math.PI / 2);
        //     height = this.width * Math.cos(radian - Math.PI / 2) + this.height * Math.sin(radian - Math.PI / 2);
        // }
        // else if (-90 <= this.rotate && this.rotate < 0)
        // {
        //     width = this.width * Math.cos(-radian) + this.height * Math.sin(-radian);
        //     height = this.height * Math.cos(-radian) + this.width * Math.sin(-radian);
        // }
        // else if (-180 <= this.rotate && this.rotate < -90)
        // {
        //     width = this.height * Math.cos(-radian - Math.PI / 2) + this.width * Math.sin(-radian - Math.PI / 2);
        //     height = this.width * Math.cos(-radian - Math.PI / 2) + this.height * Math.sin(-radian - Math.PI / 2);
        // }

        // rect.x = this.centerX - width / 2;
        // rect.y = this.centerY - height / 2;
        // rect.width = width;
        // rect.height = height;
        // return rect;
    }

    public clone()
    {
        var cloned = new Layer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : Layer)
    {
        // idは唯一なのでコピーしない
        //layer.id = this._id;
        layer.insertionId = this._insertionId;
        layer.name = this._name;
        layer.isLocked = this._isLocked;
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.layerType = this.layerType;
        jsonObject.id = this._id;
        jsonObject.insertionId = this._insertionId;
        jsonObject.name = this._name;
        jsonObject.isLocked = this._isLocked;

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : Layer
    {
        var layer = new Layer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.id != null) { this.id = jsonData.id; }
        if(jsonData.insertionId != null) { this._insertionId = jsonData.insertionId; }
        if(jsonData.name != null) { this.name = jsonData.name; }
        if(jsonData.isLocked != null) { this.isLocked = jsonData.isLocked;}
    }
}